import { render, staticRenderFns } from "./VerticalTimeline.vue?vue&type=template&id=7aa0935c&scoped=true&"
import script from "./VerticalTimeline.vue?vue&type=script&lang=js&"
export * from "./VerticalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTimeline.vue?vue&type=style&index=0&id=7aa0935c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0935c",
  null
  
)

export default component.exports